<script setup lang="ts">
import { useRouter } from 'vue-router';
const router = useRouter();

import { withDefaults, type Component } from 'vue';

const props = withDefaults(
  defineProps<{
    icon: Component | undefined;
    text: string;
    navigate: string;
    disabled?: boolean;
    small?: boolean;
    id?: string;
  }>(),

  {
    disabled: false,
    small: false,
    id: undefined,
  },
);

function redirectUser() {
  const [path, queryString] = props.navigate.split('?');

  if (queryString) {
    const queryParams = new URLSearchParams(queryString);
    const query: Record<string, string> = {};

    // Extract all query parameters
    queryParams.forEach((value, key) => {
      query[key] = value;
    });

    router.push({
      path: path,
      query: query,
    });
  } else {
    router.push({ path: path });
  }
}
</script>

<template>
  <!-- <div class="flex flex-col gap-3 items-center text-center align-bottom w-24 justify-between hover:cursor-pointer"
    :class="{ 'opacity-60 pointer-events-none': disabled }" @click="props.disabled ? undefined : redirectUser()">
    <component :is="icon" />
    <h3 class="text-xs">{{ text }}</h3>
  </div> -->

  <div
    :id="id || ''"
    :class="[
      'inline-flex flex-col items-center justify-center gap-3 rounded-xl bg-white p-2 shadow-md hover:cursor-pointer',
      props.small ? 'h-[71px] w-[71px]' : 'h-40 w-40',
      { 'pointer-events-none opacity-60': disabled },
    ]"
    @click="props.disabled ? undefined : redirectUser()"
  >
    <div :class="['inline-flex items-center justify-start gap-4 rounded-3xl', props.small ? '' : 'p-4']">
      <component :is="icon" :class="['text-primary-950', props.small ? 'h-6 w-6' : 'h-9 w-9']" />
    </div>
    <div :class="['text-center', props.small ? '' : '']">
      <h2 :class="props.small ? 'text-[9px] leading-none' : 'text-lg leading-none'">{{ text }}</h2>
    </div>
  </div>
</template>
